//保留几位小数位
export const toFixed = (number: number, precision: number) => {
  const multiplier = Math.pow(10, precision + 1),
    wholeNumber = Math.floor(number * multiplier);
  return (Math.round(wholeNumber / 10) * 10) / multiplier;
};

// 版本号对比
export const compareVersion = (version1: string, version2: string): boolean => {
  const newVersion1 = `${version1}`.split('.').length < 3 ? `${version1}`.concat('.0') : `${version1}`;
  const newVersion2 = `${version2}`.split('.').length < 3 ? `${version2}`.concat('.0') : `${version2}`;
  // 计算版本号大小,转化大小
  function toNum(a = '') {
    const c = a.toString().split('.');
    const numPlace = ['', '0', '00', '000', '0000'];
    const r = numPlace.reverse();
    for (let i = 0; i < c.length; i++) {
      const len = c[i].length;
      c[i] = r[len] + c[i];
    }
    return c.join('');
  }

  function checkVersion(a = '', b = '') {
    const numA = toNum(a);
    const numB = toNum(b);
    return numA > numB;
  }
  return checkVersion(newVersion1, newVersion2);
};

// 将数字转换为千分位  保留小数
export const dieThousand = (num: number | string, decimal = 0) => {
  if (decimal) {
    num = (Number(num) - 0).toFixed(decimal);
  }
  return (num + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
};

/**
 * 把大数字转换为'x万'，原 react 中的 handleReadPeople 方法
 * @param count number
 * @returns
 */
export const transformZeroToWan = (count: number) => {
  if (count === 0) {
    return 0;
  } else if (count > 0 && count < 10000) {
    return count;
  } else if (count >= 10000 && count < 100000) {
    const thatPeople = count.toString().slice(0, 1);
    return thatPeople + '万';
  } else if (count >= 100000 && count < 1000000) {
    const thatPeople = count.toString().slice(0, 2);
    return thatPeople + '万';
  } else {
    return '100万+';
  }
};
